import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from '../../store/auth/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private store: Store) {}

  initializeApp(): Promise<void> {
    return new Promise((resolve) => {
      // Check if user has a valid token in localStorage
      const token = localStorage.getItem('accessToken');

      if (token) {
        // Dispatch action to get current user data
        this.store.dispatch(AuthActions.getCurrentUser());
      }

      resolve();
    });
  }
}
